import * as React from 'react';

import * as styles from './ClickableText.css';

type TClickableTextProps = Omit<React.PropsWithoutRef<React.HTMLProps<HTMLSpanElement>>, 'className' | 'style'>;

export const ClickableText: React.FC<TClickableTextProps> = props => {
  return <span className={styles['element']} data-mark="Clickable" {...props} />;
};
